/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantPlanStatusEntity
 */
export interface TenantPlanStatusEntity {
    /**
     * 
     * @type {string}
     * @memberof TenantPlanStatusEntity
     */
    plan: string;
    /**
     * 
     * @type {string}
     * @memberof TenantPlanStatusEntity
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantPlanStatusEntity
     */
    quantity: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantPlanStatusEntity
     */
    isTrial: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantPlanStatusEntity
     */
    currentPeriodEnd?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantPlanStatusEntity
     */
    isContinued?: boolean;
}

/**
 * Check if a given object implements the TenantPlanStatusEntity interface.
 */
export function instanceOfTenantPlanStatusEntity(value: object): value is TenantPlanStatusEntity {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('isTrial' in value) || value['isTrial'] === undefined) return false;
    return true;
}

export function TenantPlanStatusEntityFromJSON(json: any): TenantPlanStatusEntity {
    return TenantPlanStatusEntityFromJSONTyped(json, false);
}

export function TenantPlanStatusEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantPlanStatusEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'status': json['status'] == null ? undefined : json['status'],
        'quantity': json['quantity'],
        'isTrial': json['isTrial'],
        'currentPeriodEnd': json['currentPeriodEnd'] == null ? undefined : json['currentPeriodEnd'],
        'isContinued': json['isContinued'] == null ? undefined : json['isContinued'],
    };
}

export function TenantPlanStatusEntityToJSON(json: any): TenantPlanStatusEntity {
    return TenantPlanStatusEntityToJSONTyped(json, false);
}

export function TenantPlanStatusEntityToJSONTyped(value?: TenantPlanStatusEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'status': value['status'],
        'quantity': value['quantity'],
        'isTrial': value['isTrial'],
        'currentPeriodEnd': value['currentPeriodEnd'],
        'isContinued': value['isContinued'],
    };
}

